import { ReactNode } from "react";
import { Text, Box, Center, Flex } from "@chakra-ui/react";

export const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <Center w="100%">
      <Box maxW="1232px" w="100%" p="0 16px">
        {children}
      </Box>
    </Center>
  );
};

export const Title = ({ children }: { children: ReactNode }) => {
  return (
    <Text
      fontWeight="600"
      fontSize={{ base: "40px", md: "64px" }}
      color="#3A3636"
      lineHeight="120%"
      letterSpacing="-3px"
    >
      {children}
    </Text>
  );
};

export const SubTitle = ({ children }: { children: ReactNode }) => {
  return (
    <Text
      fontWeight="400"
      fontSize={{ base: "12", md: "16px" }}
      color="textSecondary"
      lineHeight="120%"
    >
      {children}
    </Text>
  );
};

export const Section = ({ children }: { children: ReactNode }) => {
  return (
    <Flex
      py={{ base: "64px", md: "60px" }}
      flexDir="column"
      gap={{ base: "24px", md: "48px" }}
    >
      {children}
    </Flex>
  );
};
